import { APIFacetField } from '@common/types/queryState';
import { useMemo, useState } from 'react';

export const useStickyFacets = (
    currentFacets: APIFacetField[],
    baselineFacets: APIFacetField[],
) => {
    const [isStickyEnabled, setIsStickyEnabled] = useState(true);
    const hasBaseline = !!(baselineFacets && baselineFacets.length > 0);

    const displayFacets = useMemo(() => {
        return isStickyEnabled && hasBaseline ? baselineFacets : currentFacets;
    }, [baselineFacets, currentFacets, hasBaseline, isStickyEnabled]);

    return {
        displayFacets,
        realTimeFacets: currentFacets,
        isStickyEnabled,
        setIsStickyEnabled,
        hasBaseline,
    };
};
